import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  /**
   * Get data from session storage
   *
   * @param key defines, which item of session storage should be recieved
   * @return requested icon from session storage
   */
  get(key: string) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      console.error('Could not read from session storage', error);
    }
  }

  /**
   * Set data in session storage
   *
   * @param key defines, which item should be added session storage
   * @param value defines, which value should be added session storage key
   */
  set(key: string, value: string) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      console.error('Could not write to session storage', error);
    }
  }

  /**
   * Removes key from session storage
   *
   * @param key defines, which item should be removed from session storage
   */
  remove(key: string) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      console.error('Could not delete from session storage', error);
    }
  }

  // clears the whole session storage
  clear() {
    try {
      window.sessionStorage.clear();
    } catch (error) {
      console.error('Could not clear session storage', error);
    }
  }
}
